
<template>

	<div v-if="data" class="h-100">
		
		<net_operating_income v-if="active_step.startsWith('profitable_step1')"
			:id="id"
			:group_id="group_id"
			:objects_count="data.total_objects" :data="data.net_operating_income"
			v-on:set_value="(key, value) => set_value('net_operating_income.' + key, value)"
			v-on:need_refresh="() => refresh()"
			:active_step="active_step" v-on:set_active_step="(step_id) => $emit('set_active_step', step_id)"
			v-on:update_counts="() => update_counts()"
			:not_editable="not_editable"
			:capitalization_data="data"
		/>

		<capitalization_rate v-if="active_step.startsWith('profitable_step2')"
			:id="id"
			:group_id="group_id"
			:analogues_count="data.total_analogues" :data="data.capitalization_rate" v-on:set_value="(key, value) => set_value('capitalization_rate.' + key, value)"
			:active_step="active_step" v-on:set_active_step="(step_id) => $emit('set_active_step', step_id)"
			v-on:update_counts="() => update_counts()"
			:not_editable="not_editable"
		/>

		<setup_content v-if="active_step == 'profitable_step3'" title="Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости">

			<element_row
				title="Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости" :data="data.price_share"
				:validation="price_share_validation" v-on:set_value="(key, value) => set_value(`price_share.${key}`, value)"
				:readonly="!check_roles([ 'model' ]) || not_editable"
			/>

		</setup_content>

		<setup_content v-if="active_step == 'profitable_step4'" title="Модель определения кадастровой стоимости" class="main-container">

			Кадастровая стоимость = (Чистый операционный доход единого объекта недвижимости / Ставка капитализации) * Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости
			
			<div class="mt-2 d-flex justify-content-center" style="gap: 16px">
				<b-button v-if="check_roles([ 'cost' ]) && !not_editable" class="d-flex align-items-center" style="gap: .25rem" variant="primary" v-on:click="calculate">
					<base-icon name="calc"/>Рассчитать кадастровую стоимость
				</b-button>
			</div>

            <details_profitable ref="details" :group_id="group_id" :cost_evaluation_data="cost_evaluation_data" />

		</setup_content>

	</div>

</template>

<script>
import api from "../../../../../api"
import setup_content from "../setup_assets/content"
// import statistic from "../setup_assets/statistic"
import net_operating_income from "./net_operating_income"
import capitalization_rate from "./capitalization_rate"
import details_profitable from "./details"
import element_row from "../../../../widgets/element-row.vue"

export default
{
	props :
	{
		id : String,
		group_id : String,
		// data : Object,
		cost_evaluation_data : Object,
        active_step : String,
		not_editable : Boolean
	},

	components :
	{
		details_profitable,
        setup_content,
		// statistic,
		net_operating_income,
		capitalization_rate,
		element_row
	},

	data()
	{
		return {

			service : "cadastral_cost_evaluation",
            data : null,
			price_share_state : null,
			price_share_validation :
			{
				check: (value) => api.check_number({ value : value, gte : 0, lte : 1 }),
				msg: "От 0 до 1"
			}

		}
	},

	watch :
	{
		active_step :
		{
			immediate : true,

			handler(active_step)
			{
				if(active_step == "profitable_step1_1_1_2")
					api.call_long_operation(this, "Расчет потенциальной арендной платы объектов-аналогов", "cadastral_cost_evaluation", "evaluate_rent_price", { id : this.id },
						response =>
						{
							api.open_response_url(response)

							this.refresh()
						})
			}
		},
	},

	mounted()
	{
		this.refresh()
	},

	methods :
	{
		refresh()
		{
			const oldData = api.deep_clone(this.data)
			api.call(this, this.service, "get", { id : this.id },
				response =>
				{
					this.data = response.data.capitalization
				}).then(() => {
				var steps = []
				
				if (this.data.net_operating_income.actual_gross_income.potential_gross_income.type == 'Рассчитать на данных об объектах-аналогах')
				{
					steps.push({ id: 'profitable_step1_1_1_2', not_visible : false, })
					
					steps.push({
						id: 'profitable_step1_1_1_3',
						not_visible : !this.data.net_operating_income.actual_gross_income.potential_gross_income.analogues.with_season_factors
					})
				}
				else steps.push({ id: 'profitable_step1_1_1_2', not_visible : true, }, { id: 'profitable_step1_1_1_3', not_visible : true, }, )
				
				this.$emit('set_steps_value', steps)

				if (oldData && this.check_roles([ 'model' ])) {
					const old_pgi = oldData.net_operating_income.actual_gross_income.potential_gross_income
					const new_pgi = this.data.net_operating_income.actual_gross_income.potential_gross_income
	
					if (
						old_pgi.attr !== new_pgi.attr
						|| (old_pgi.type !== new_pgi.type && new_pgi.type === "Рассчитать на данных об объектах-аналогах")
						|| old_pgi.analogues.with_season_factors !== new_pgi.analogues.with_season_factors
					) {
						api.call_long_operation(this, "Расчет потенциальной арендной платы объектов-аналогов", "cadastral_cost_evaluation", "evaluate_rent_price", { id : this.id },
							response =>
							{
								api.open_response_url(response)

								this.refresh()
							})
					}

					const old_cr = oldData.capitalization_rate
					const new_cr = this.data.capitalization_rate

					if (
						(
							old_cr.type != new_cr.type
							&& (
								new_cr.type == "Метод рыночной экстракции (на основе группы пар данных)"
								|| new_cr.type == "Метод рыночной экстракции (на основе пары групп данных)"
							)
						)
						|| (
							old_cr.net_operating_income.type != new_cr.net_operating_income.type
							&& (
								(
									new_cr.net_operating_income.type == "С учетом доли операционных расходов"
									&& new_cr.net_operating_income.correction.value && new_cr.net_operating_income.operating_expenses_share.value
								)
								|| (
									new_cr.net_operating_income.type == "С учетом доли чистого операционного дохода"
									&& new_cr.net_operating_income.share.value
								)
							)
						)
						|| (
							new_cr.net_operating_income.correction.value && new_cr.net_operating_income.operating_expenses_share.value
							&& (
								old_cr.net_operating_income.correction.value != new_cr.net_operating_income.correction.value
								|| old_cr.net_operating_income.operating_expenses_share.value != new_cr.net_operating_income.operating_expenses_share.value
							)
							|| (
								new_cr.net_operating_income.share.value
								&& old_cr.net_operating_income.share.value != new_cr.net_operating_income.share.value
							)
						)
						|| (
							old_cr.net_operating_income.type != new_cr.net_operating_income.type
						)
					) {
						api.call_long_operation(this, "Подбор объектов-аналогов", "cadastral_cost_evaluation", "evaluate_capitalization_rate", { id : this.id },
							response =>
							{
								api.open_response_url(response)

								// this.refresh()
							})
					}
				}
			})
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

        set_value(key, value)
        {
			if (this.check_roles([ 'model' ]) && !this.not_editable)
			{
				api.call(this, this.service, "set_field", { id : this.id, field : "capitalization." + key, value : value }, () => {
					api.show_notification(this, "Изменения сохранены")
					this.refresh()
				})
			}
        },

		update_counts()
		{
			if (this.check_roles([ 'model' ]))
			{
				api.call(this, this.service, "capitalization_update_counts", { id : this.id }, () => this.refresh())
			}
		},

		calculate()
		{
			if (this.check_roles([ 'cost' ]) && !this.not_editable)
			{
				if(this.data.price_share.value == 0)
				{
					api.show_notification(this, "Невозможно запустить расчет. Не заполнено поле: \"Наиболее вероятная доля стоимости объекта оценки в стоимости единого объекта недвижимости\"")
					
					return
				}

				api.call_long_operation(this, "Группа / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_groups", "set_cost",
					{ id : this.group_id, calculation_types : [ "Доходный подход" ], evaluate_result_cost : false },
					response =>
					{
						api.open_response_url(response)

						this.$refs.details.refresh()
					},
					{ success_msg : "Расчет КС завершен" }
				)
			}
		},
	}
}

</script>

